import { HttpMethods } from './http-methods';

export class HttpMethodsSerializer {

  fromJson(json: any): HttpMethods {
    const httpMethods = new HttpMethods();

    if (typeof json.success !== 'undefined') {
      httpMethods.success = json.success;
      httpMethods.data = this.toJson(json.data);
      return httpMethods;
    } else {
      return this.toJson(json);
    }
  }

  toJson(httpMethods: HttpMethods): any {
    if (typeof httpMethods === 'object') {
      return {
        id: httpMethods.id,
        title: httpMethods.title,
      };
    } else {
      return httpMethods;
    }
  }
}
